"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = (key) => {
    if (typeof window !== 'undefined') {
        return window.localStorage.getItem(key);
    }
    else {
        return null;
    }
};
exports.set = (key, value) => {
    if (typeof window !== 'undefined') {
        return window.localStorage.setItem(key, value);
    }
    else {
        return null;
    }
};



// WEBPACK FOOTER //
// ./src/helpers/local-storage.ts